module.exports = __webpack_public_path__ + "img/ai3.ab0c33fc.png";